export const correctAngle = (angle: number): number => {
	return angle < 0 ? 360 + angle : angle;
}
